export const getAddress = (id: number) => {
    switch (id) {
        case 1: return 'Panadura Road, Bandaragama';
        case 2: return 'Level 5, One Galle Face Mall';
        case 3: return 'Level 2, Havelock City Mall';
        case 4: return 'Level 5, One Galle Face Mall';
        case 5: return 'Pop Up Store';
        default: return 'Panadura Road, Bandaragama';
    }
}